import styled from 'styled-components/macro';
import { Form as FormFormik } from 'formik';
import { applyStyleModifiers } from 'styled-components-modifiers';

const FORM_MODIFIERS = {
  stretch: () => `
    width: 100%
  `,
  shrink: () => `
    max-width: 708px;
  `,
};

const Form = styled(FormFormik)`
  display: flex;
  flex-direction: column;
  ${applyStyleModifiers(FORM_MODIFIERS)};
`;

const ACTIONS_MODIFIERS = {
  start: () => `
    justify-content: flex-start;
  `,
};


Form.Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.l};
  ${applyStyleModifiers(ACTIONS_MODIFIERS)};
`

export default Form;
